import { useEffect } from 'react';
import { useMutation } from '@tanstack/react-query';
import { toast } from '@huspy/forge/shared';
import { useTranslation } from 'react-i18next';
import queryClient from '@app/queryClient';
import { coreApi } from '../../api';

const useUpdateBrokerTnCs = (authenticatorId: string) => {
  const { t } = useTranslation();

  const {
    error, mutate, isPending, mutateAsync,
  } = useMutation({
    mutationKey: ['updateBrokerTnCs'],
    mutationFn: () => coreApi.updateBrokerTnCs(authenticatorId, TERMS_AND_CONDITIONS_VERSION),
    onSuccess: (_) => {
      queryClient.invalidateQueries({ queryKey: ['brokerProfile', authenticatorId] });
      queryClient.invalidateQueries({ queryKey: ['accountManagement'] });
      queryClient.invalidateQueries({ queryKey: ['featureFlags', authenticatorId] });
      toast('info', { message: t('account.updatedSuccess') });
    },
  });

  useEffect(() => {
    if (error) {
      toast('error', { message: error.message });
    }
  }, [error]);

  return {
    mutate,
    error,
    isPending,
    mutateAsync,
  };
};

export default useUpdateBrokerTnCs;
